import styled from 'styled-components'
import { ReactComponent as ArrowRight } from 'ASSETS/svg/icon_arrowright.svg'
import React from 'react'

const ActiveButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  width: 110px;
  height: 38px;
  background: #3370ff;
  box-shadow: 0px -1px 1px #f7f7f8, 0px 5px 12px rgba(147, 157, 168, 0.24);
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #ffffff;
  :hover {
    background: #2152d9;
    .arrow-right {
      fill: #2152d9;
      animation-name: move;
      animation-timing-function: ease;
      animation-duration: 1s;
      transform-origin: bottom;
    }
    @keyframes move {
      0% {
        transform: translateX(0);
      }
      50% {
        transform: translateX(16px);
      }
      51% {
        transform: translateX(-16px);
      }
      100% {
        transform: translateX(0);
      }
    }
  }
  box-sizing: border-box;
`

const ArrowContaienr = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 7px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
`

const IconArrowRight = styled(ArrowRight)`
  fill: #3370ff;
  transition: all linear 0.2s;
`

const Button: React.FC<React.HTMLProps<HTMLDivElement>> = ({ children, ...props }) => {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    //@ts-ignore
    <ActiveButton {...props}>
      {children}
      <ArrowContaienr>
        <IconArrowRight className="arrow-right" />
      </ArrowContaienr>
    </ActiveButton>
  )
}

export default Button
